<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="loadingItems" class="loading">
                    <p>{{loadingMessage}}</p>
                </div>
            </transition>
        </div>

    <b-container>
        <b-row>
            <b-col>
                <h4 style="margin-top:20px">Forums</h4>
            </b-col>
        </b-row>

        <!-- Post new thread -->
        <b-row>
            <b-col>
                <!-- Check User Credentials to start a thread -->
                <b-button style='margin-bottom:10px; margin-left:2px'  @click="checkUserCreds()" variant="outline-info">Start New Thread</b-button>

                <!-- Modal to add user handle  and accept terms -->
                <b-modal :no-close-on-backdrop="true" id='addusercred' title="Choose a display name"  ok-title ='Accept' cancel-title ='Cancel'  @ok="saveUserCreds">
                    <p class="my-4">Enter a display handle. </p>
                    <small>This display handle will show, along with your company's name in all your posts</small>
                    <b-form-input v-model="userHandle" ></b-form-input>
                    <div v-if="handleExists" style='color:red'>Sorry this handle is already taken</div>
                </b-modal>

                <!-- Modal to start new thread -->
                <b-modal  :no-close-on-backdrop="true" size='xl' id='startthread' title="Start New Post"  :hide-footer="true">

                    <newforumthread @closeNewThreadModal="closeNewThreadModal" :userHandle="userHandle" />
                </b-modal>
            </b-col>
        </b-row>

        <!-- Show all forum subjects -->
        <!-- Forum Cards -->
        <b-card v-for="theTitle in forumTitles" :key="theTitle.docId+'card'" header-tag="header" footer-tag="footer" 
            style="cursor:pointer; margin-bottom:20px" @click="showForumThread(theTitle.docId)">
            <!-- Header -->
            <template #header >
                <small style="color:gray">Started By: @{{theTitle.createdbyhandle}}, {{theTitle.createdbycompany}} on {{theTitle.dateObject}}</small>
                <h6 class="mb-0">{{getTruncatedText(theTitle.subject,75)}}</h6>
            </template>
            <small style="color:gray">Last Post By: @{{theTitle.lastposthandle}} on {{theTitle.lastPostDateObject}}: </small> 
                <small style="margin-left:20px">{{getTruncatedText(theTitle.lastpost, 200)}}</small>
            <br>

            <!-- Footer -->
            <template #footer>
                <small><i><font-awesome-icon icon="comment" /></i> {{theTitle.totalposts}} Comments</small><small style="margin-left:50px"> <span v-if="theTitle.votes>0">+</span> {{theTitle.votes}} votes  <span style="margin-left:50px">{{theTitle.views}} views</span></small>
            </template>
        </b-card>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import firebase from 'firebase/app';
const fb = require('../../firebaseConfig.js')
import axios from 'axios'
import {timeConverterObject} from '../Myfunctions'
import {timeConverter} from '../Myfunctions'
import Newforumthread from './Newforumthread'


export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Newforumthread,
    },

    data() {
        return {
            loadingItems:false,
            loadingMessage:'',
            userHandle:'',
            errMsg:'',
            handleExists:false,
            newPost:{
                subject:'',
                post:'',
                createdOn:'',
                createdByHandle:'',
                createdByCompany:'',
                createdByUid:'',
            },
            newPostError:false,
            forumTitles:[],

            
        }
    },

    methods:{

        //Get truncated title if too long
        getTruncatedText(theString, length){
            var theTitle = theString
            if(theTitle.length>length) theTitle = theTitle.slice(0, length) + '....'
            return theTitle
        },

        //Check user credentials to start a new thread
        checkUserCreds(){
            //If no screen name, ask for screen name
            if(!this.userHandle) this.$bvModal.show("addusercred")
            //Else show start new thread
            else this.$bvModal.show("startthread")

        },

        //Save users new screen name
        saveUserCreds(bvModalEvt){
            //Wait till this screen name is checked
            bvModalEvt.preventDefault()
            this.handleExists=false
            this.errMsg=""
            fb.displayHandlesCollection.where('userhandle', '==', this.userHandle).get().then(docs => {
                docs.forEach(doc => {
                    const theData = doc.data()
                    this.handleExists=true
                    this.userHandle=''
                })

                //If handle doesn't exist, assign it to user
                if(!this.handleExists){
                    //Assign to user
                    fb.usersCollection.doc(this.currentUser.uid).update({
                        userhandle:this.userHandle
                    })
                    //Add to handles collection
                    fb.displayHandlesCollection.doc(this.currentUser.uid).set({userhandle:this.userHandle, uid:this.currentUser.uid, company:this.userProfile.company})
                    this.$bvModal.hide("addusercred")
                    //Show the start thread modal
                    this.$bvModal.show("startthread")
                }
            }).catch(err => {
                console.log(err)
            })

        },

        //Get the titles and last message for all forums
        getAllForumMessageTitles(){
            this.loadingItems=true
            this.loadingMessage=" Loading Forum "
            console.log("Getting titles")
            this.forumTitles=[]
            fb.forumTitlesCollection.orderBy("lastpostdate", "desc").get().then(docs => {
                docs.forEach(doc => {
                    var thisForum = doc.data()
                    thisForum.docId = doc.id
                    
                    if(thisForum.createdOn){
                        thisForum.dateObject = timeConverter(thisForum.createdOn.seconds)
                        thisForum.date = thisForum.dateObject.day + ", " + thisForum.dateObject.month + ' '+ thisForum.dateObject.date + ' ' + thisForum.dateObject.time
                        thisForum.lastPostDateObject = timeConverter(thisForum.lastpostdate.seconds)
                    } 
                    this.forumTitles.push(thisForum)
                })
            })
            .then(res => {
                this.loadingItems=false
            }).catch(err => {
                this.loadingItems=false
                console.log("Error getting items")
            })
        },

        //Close new thread modal
        closeNewThreadModal(){
            this.getAllForumMessageTitles()
            this.$bvModal.hide("startthread")
            
        },

        //Show forum thread
        showForumThread(threadid){
            //Upate views
            var increment = firebase.firestore.FieldValue.increment(1);
            fb.forumTitlesCollection.doc(threadid).update({ views: increment});

            this.$store.commit('setCurrentForumThreadId',threadid)
            this.$router.push('/forumthreaddetails')
        },  


    },

    mounted(){
        //Set user handle
        if(this.userProfile.userhandle) this.userHandle=this.userProfile.userhandle
        this.getAllForumMessageTitles()
    },
}
</script>

